import React from "react"
import Link from "gatsby-link"
import SVGInline from 'react-svg-inline'
import Img from "gatsby-image"

class ArticleListItem extends React.Component {
  render() {
    const article =  this.props.node;
    let { tags } = article;

    return (
      <div key={article.slug} className="c-article-list">

        <Link to={`/articole/${article.slug}/`} className="c-link-simple">

          {article && article.cover && article.cover.resolutions && article.cover.resolutions.src && (
            <Img
              className="c-article-list__cover"
              alt={article.cover.title}
              resolutions={article.cover.resolutions}
            />
          )}

        </Link>

        <div className="c-article-list__content">
          <Link to={`/articole/${article.slug}/`} className="c-link-simple">
            <h3 className="c-article-list__title u-h3">
              {article.title}
            </h3>
          </Link>

          <div className="c-article-misc">
            <div className="c-article-date">
              <ul className="o-list-inline o-list-05 u-mb-0 o-media__body">
                <li className="o-list-inline__item">
                  {article.date}
                </li>
              </ul>
            </div>
            <span className="u-ph-10 c-article-misc__separator">|</span>
            <div className="c-article-tags">
                <ul className="o-list-inline o-list-05 u-mb-0 o-media__body">
                {tags.map((tag, i) => (
                  <li key={i} className="o-list-inline__item">
                    <Link to={`/articole/etichete/${tag.slug}/`} className="c-tag">
                      {tag.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <p className="c-article-list__excerpt">{article.excerpt}...</p>
          <Link to={`/articole/${article.slug}/`} className="c-link u-font-size-15">
            CITESTE MAI DEPARTE
          </Link>

        </div>
      </div>
    );
  }
}

export default ArticleListItem


// WEBPACK FOOTER //
// ./src/components/articleListItem.js